import { render, staticRenderFns } from "./InfoContent.vue?vue&type=template&id=3e2550ed&scoped=true&"
import script from "./InfoContent.vue?vue&type=script&lang=js&"
export * from "./InfoContent.vue?vue&type=script&lang=js&"
import style0 from "./InfoContent.vue?vue&type=style&index=0&id=3e2550ed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2550ed",
  null
  
)

export default component.exports